import { getLocaleFromPath, getLocalePrefix } from './locales'

export const buildPrivateAccessPath = (
  sourcePath: string,
  intentContext = 'nightlife_article',
  sourceCategory = 'magazine'
) => {
  const localePrefix = getLocalePrefix(getLocaleFromPath(sourcePath))
  const homePath = localePrefix || '/'
  const query = new URLSearchParams({
    pa_source: sourcePath,
    pa_context: intentContext,
    pa_category: sourceCategory
  })

  return `${homePath}?${query.toString()}#private-access`
}
